import React from "react";
import { NavLink } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { deleteCardOrAccount } from "../../redux/thunks/userThunks";

const SettingsAccountCard = ({
  id,
  type,
  iconClass,
  title,
  description,
  maskedValue,
  verified,
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user.data);

  const handleDelete = async () => {
    if (
      window.confirm("Are you sure you want to delete this account or card?")
    ) {
      await dispatch(deleteCardOrAccount(user.email, id, type));
    }
  };

  return (
    <li>
      <div className="row">
        <div className="col-9">
          <div className="d-flex">
            <span className="me-3">
              <i className={iconClass}></i>
            </span>
            <div className="flex-grow-1">
              <h5 className="mt-0 mb-1">{title}</h5>
              <p>{description}</p>
              <p>{maskedValue}</p>
            </div>
            <div className="edit-option">
              <NavLink onClick={handleDelete}>
                <i className="fa fa-trash"></i>
              </NavLink>
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="verify">
            <div className={verified ? "verified" : "not-verify"}>
              <span>
                <i className={`la ${verified ? "la-check" : "la-close"}`}></i>
              </span>
              <NavLink>{verified ? "Verified" : "Not verified"}</NavLink>
            </div>
          </div>
        </div>
      </div>
      <br />
    </li>
  );
};

export default SettingsAccountCard;
